import { render, staticRenderFns } from "./FilterManagementTable.vue?vue&type=template&id=2836159c&scoped=true&"
import script from "./FilterManagementTable.vue?vue&type=script&lang=js&"
export * from "./FilterManagementTable.vue?vue&type=script&lang=js&"
import style0 from "./FilterManagementTable.vue?vue&type=style&index=0&id=2836159c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836159c",
  null
  
)

/* custom blocks */
import block0 from "./FilterManagementTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2836159c')) {
      api.createRecord('2836159c', component.options)
    } else {
      api.reload('2836159c', component.options)
    }
    module.hot.accept("./FilterManagementTable.vue?vue&type=template&id=2836159c&scoped=true&", function () {
      api.rerender('2836159c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filter-management/FilterManagementTable.vue"
export default component.exports